export default {
      id: "ic_quotidien-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_quotidien-usage",
      toString: function () {
        return this.url;
      }
    }